/**
 * Descarga la respuesta de la API como fichero.
 *
 * Los endpoints de documentos exigen token, asi que no se puede apuntar un
 * enlace directamente a la URL: se pide con axios y se guarda el blob.
 */
export default function downloadFile(response, fallbackName = 'documento') {
  const disposition = response.headers?.['content-disposition'] || '';
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  const filename = match ? match[1] : fallbackName;

  const url = window.URL.createObjectURL(new Blob([response.data], {
    type: response.headers?.['content-type'] || 'application/octet-stream',
  }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
  return filename;
}
